<script lang="ts">
  import type { ManageAPI } from "~/manage-api/types";
  import type { StoresKey } from "~/stores";
  import { getStoresContext } from "~/stores";
  import OfferView from "~/components/statistics/OfferView.svelte";
  
  export let offer: ManageAPI.Offer;
  export let request_store_key: StoresKey;
  export let inSwiper = false;

  const { reverse_router, stores, scdata, site } = getStoresContext(request_store_key);

  $: store = $stores && $stores.find((store) => store.id == offer.store?.id);
  $: logo = store?.logoURL;
  $: alt = store?.name || $site.name;
  $: id = offer.id;
  $: href = store ? $reverse_router.routeStore(store, $scdata) || "" : undefined;

  function handleStoreClick(e: MouseEvent) {
    e.stopImmediatePropagation();
    e.preventDefault();
  }
</script>

{#if inSwiper}
  <OfferView {id} on:focusOffer>
    <div class="offer-card">
      <div class="square cut-bottom-left">
        {#if offer.images && offer.images.length}
          <img src={offer.images.at(0)} alt={alt} />
        {:else}
          <img src={logo} alt={alt} />
        {/if}
        <div class="offer-validity">
          {offer.title}
        </div>
      </div>

      <div class="content-wrapper">
        {#if store}
          <a 
            class="publisher" 
            {href}
            on:click|stopPropagation|preventDefault={handleStoreClick}
            on:click|capture|stopPropagation
          >{alt}</a>
        {:else}
          <span class="publisher">{alt}</span>
        {/if}
        <p>{offer.description1} {offer.description2}</p>
        {#if id && offer.longDescription}
          <p class="long-description mt-3">{offer.longDescription}</p>
        {/if}
      </div>
    </div>
  </OfferView>
{:else}
  <OfferView {id} on:focusOffer>
    <div class="square cut-bottom-left mb-3">
      {#if offer.images && offer.images.length}
        <img src={offer.images.at(0)} alt={alt} />
      {:else}
        <img src={logo} alt={alt} />
      {/if}
      <div class="offer-validity">
        {offer.title}
      </div>
    </div>

    <div class:px-3={id} class:pb-3={id}>
      {#if store}
        <a 
          class="mb-2 publisher px-0" 
          {href}
          on:click|stopPropagation|preventDefault={handleStoreClick}
          on:click|capture|stopPropagation
        >{alt}</a>
      {:else}
        <span class="mb-2 publisher px-0">{alt}</span>
      {/if}
      <p>{offer.description1} {offer.description2}</p>
      {#if id && offer.longDescription}
        <p class="mt-3">{offer.longDescription}</p>
      {/if}
    </div>
  </OfferView>
{/if}

<style lang="scss">
  .publisher-link {
    text-decoration: none;
    color: inherit;
    pointer-events: none;
    
    .publisher {
      text-decoration: underline;
      color: var(--brand-color-1);
      pointer-events: auto;
    }
  }

  .offer-card {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    cursor: pointer;
    transition: transform 0.2s ease;
    overflow: hidden;
  }

  .square {
    position: relative;
    background: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    aspect-ratio: 1;
    cursor: pointer;
    border: 1px solid #ddd;

    img {
      max-width: 100%;
      max-height: 100%;
      position: absolute;
      -webkit-transition: 0.5s all ease-in-out;
      transition: 0.5s all ease-in-out;
    }

    &:hover img {
      transform: scale(1.13);
    }
  }

  .offer-validity {
    position: absolute;
    bottom: -1px;
    left: -1px;
    color: #fff;
    padding: 0.4rem 0.6rem;
    background-color: var(--brandColor1);
    font-weight: 500;
    font-size: 17px;
    z-index: 1;
  }

  .content-wrapper {
    flex: 1;
    display: flex;
    flex-direction: column;
    padding: 1rem;
  }

  .publisher {
    position: relative;
    z-index: 2;
    background: none;
    border: none;
    color: var(--brand-color-1);
    font-size: 16px;
  }

  a.publisher {
    text-decoration: underline;
  }

  p {
    margin: 0;
    line-height: 1.5;
    color: var(--color-black);
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  .long-description {
    margin-top: 0.5rem;
  }
</style>
